import { EntityService } from '../../core/services/entity.service';
import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Headers } from '@angular/http';
import { Policy } from '../model/policy';

@Injectable()
export class PoliciesService {

    constructor(private http: GlobalService, private entityService: EntityService) {
    }

    search(data: any): Observable<Policy[]> {
        const url = `policies`;
        return this.http.post(url, data)
            .map(res => this.entityService.extractData<Policy[]>(res))
            .map(resData => {
                return resData.map(dataItem => {
                    const policy = new Policy(dataItem.since, dataItem.until, dataItem.dueDate);
                    return this.entityService.copy(dataItem, policy);
                });
            });
    }

    downloadAndSaveActionRegister(itemId: number, userActionTypeId: number) {
        const url = `policies/downloadAndSaveActionRegister/${itemId}/${userActionTypeId}`;

        const headers = new Headers();
        headers.append('Content-Type', 'application/pdf');
        headers.append('responseType', 'arrayBuffer');

        return this.http.file(url, null, headers)
            .map(x => {
                const blob = new Blob([x.payload.blob()], { type: 'application/pdf' });

                let fileName;

                switch (userActionTypeId) {
                    case 3:
                        fileName = "Poliza";
                        break;
                    case 4:
                        fileName = "Tarjeta";
                        break;
                    case 5:
                        fileName = "Certificado";
                        break;
                    default:
                        fileName = "download";
                        break;
                }

                window['saveAs'](blob, fileName);
            });
    }

    getValids(): Observable<Policy[]> {
        const url = `policies/valids`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<Policy[]>(res))
            .map(data => {
                return data.map(dataItem => {
                    const policy = new Policy(dataItem.since, dataItem.until, dataItem.dueDate);
                    return this.entityService.copy(dataItem, policy);
                });
            });
    }

    getAll(): Observable<Policy[]> {
        const url = `policies`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<Policy[]>(res))
            .map(data => {
                return data.map(dataItem => {
                    const policy = new Policy(dataItem.since, dataItem.until, dataItem.dueDate);
                    return this.entityService.copy(dataItem, policy);
                });
            });
    }

    getCupon(id: number): Observable<any> {
        const url = `policies/${id}/cupon`;

        const headers = new Headers();
        headers.append('Content-Type', 'application/pdf');
        headers.append('responseType', 'arrayBuffer');

        return this.http.file(url, null, headers)
            .map(x => {
                const blob = new Blob([x.payload.blob()], { type: 'application/pdf' });

                window['saveAs'](blob, 'cupon de pago.pdf');
            });
    }

    getPaymentConstancy(idpv: number): Observable<any> {
        const url = `policies/getPaymentConstancy/${idpv}`;

        const headers = new Headers();
        headers.append('Content-Type', 'application/pdf');
        headers.append('responseType', 'arrayBuffer');

        return this.http.file(url, null, headers)
            .map(x => {
                const blob = new Blob([x.payload.blob()], { type: 'application/pdf' });

                window['saveAs'](blob, 'Constancia de Pago.pdf');
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/policies.service.ts